import { put, takeLatest, call } from "redux-saga/effects";
import * as memberAction from "../actions/ActionCreator";
import * as memberType from "../actions/ActionType";
import * as Api from "../../appApi/AppApi";
import { API_ENDPOINT } from "../URLs/ApiEndpoints";

const TAG = "confirmWhatsAppSubmissionSaga.js";

function* workerConfirmWhatsAppSubmission(payLoad) {
  console.log(
    TAG,
    "worker confirmWhatsAppSubmissionSaga : " + JSON.stringify(payLoad)
  );
  console.log(
    TAG,
    "worker confirmWhatsAppSubmissionSaga : " + JSON.stringify(payLoad.data)
  );
  try {
    const response = yield call(
      Api.makeSecuredPostRequest,
      API_ENDPOINT.CONFIRM_BOT_SUBMISSION +
        `?bot_id=${payLoad.data.bot_id}&channel_type=${payLoad.data.channel_type}`,
      {}
    );
    console.log(
      TAG,
      "worker confirmWhatsAppSubmissionSaga Response: " +
        JSON.stringify(response)
    );
    yield put(memberAction.confirmWhatsAppSubmissionSuccess(response));
  } catch (error) {
    console.log(
      TAG,
      "Worker confirmWhatsAppSubmissionSaga error: " + error.message
    );
    yield put(memberAction.confirmWhatsAppSubmissionFailed(error.message));
  }
}

export const watchConfimWhatsAppSubmission = takeLatest(
  memberType.CONFIRM_WHATSAPP_SUBMITION,
  workerConfirmWhatsAppSubmission
);
